// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ICBue","logo":"Footer_logo__EzaX5","text":"Footer_text__vtkk7"};